import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, MerchantService } from 'app/services';
import { AppComponent } from 'app/app.component';
import { ByMerchantRequestDto } from 'app/models';

@Component({
    selector: 'partner-settings-payout-account',
    templateUrl: './partner-settings-payout-account.component.html',
    styleUrls: ['./partner-settings-payout-account.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class PartnerSettingsPayoutAccountComponent implements OnInit {
    @Input() public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public appData: AppDataService,
        private merchantService: MerchantService, public app: AppComponent) {
        this.handleHidePaymentDetailSideBar = this.handleHidePaymentDetailSideBar.bind(this);
    }
    ngOnInit(): void {
        this.getMerchantPayoutAccounts();
    }

    public loading: boolean = false;
    public showMerchantAddPaymentSideBar: boolean = false;
    public showMerchantDetailPaymentSideBar: boolean = false;

    public payments: any = [];
    public selectedPayment: any;

    public getMerchantPayoutAccounts() {
        const request: ByMerchantRequestDto = {
            MerchantId: parseInt(this.appData.authData.MerchantId, 10)
        };

        this.loading = true;

        this.merchantService.getMerchantPayoutAccounts(request, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.payments = data.Items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    changedShowMerchantAddPaymentSideBarEmit(value: boolean) {
        this.showMerchantAddPaymentSideBar = value;
    }

    public handleShowPaymentDetailSideBar(payment: any) {
        this.selectedPayment = payment;
        this.showMerchantDetailPaymentSideBar = true;
    }

    public handleHidePaymentDetailSideBar() {
        this.showMerchantDetailPaymentSideBar = false;
    }
}
